<div id="calendar-header">
  <div class="calendar-header-stepper">
    <nimbus-input-date-picker
      [removable]="false"
      [formControl]="selectedDateControl"
      id="selectedDateControl"
      [label]="TranslationKeys.GeneralDate | translate"
    >
    </nimbus-input-date-picker>
    <button nimbusPrimaryIconButton (click)="previous()"><i [nimbusIcon]="ICONS.CHEVRON_LEFT"></i></button>
    <button nimbusInvertedButton (click)="today()">{{ TranslationKeys.GeneralToday | translate }}</button>
    <button nimbusPrimaryIconButton (click)="next()"><i [nimbusIcon]="ICONS.CHEVRON_RIGHT"></i></button>
  </div>
  <div class="calendar-header-view">
    @for (viewOption of views; track viewOption) {
      @if (viewOption !== view) {
        <button nimbusSecondaryButton (click)="changeView(viewOption)">
          {{ viewTranslationKeys[viewOption] | icuTranslate }}
        </button>
      } @else {
        <button nimbusPrimaryButton>{{ viewTranslationKeys[viewOption] | icuTranslate }}</button>
      }
    }
  </div>
</div>
